import NoteMakerPWA from './NoteMakerPWA.png';
import SafeKeeping from './SafeKeeping.png';
import WeatherDashboard from './WeatherDashboard.png';
import WizDumb from './WizDumb.png';


// Here I am importing all the images of the projects being displayed through the Project component in the Portfolio page


export default  {NoteMakerPWA, SafeKeeping, WeatherDashboard, WizDumb}

